import { StyleSheet, Platform } from 'react-native';

import { Fonts } from '../Themes';

export default StyleSheet.create({
  viewIconContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 53,
  },
  iconContainer: {
    height: 125,
    width: 125,
  },
  title: {
    alignSelf: 'center',
    marginTop: 33,
    fontSize: Platform.OS === 'ios' ? 28 : 29.1,
    ...Fonts.type.bold,
  },
  viewDescription: {
    alignSelf: 'center',
    marginTop: 20,
    fontSize: Platform.OS === 'ios' ? 18 : 18.7,
    lineHeight: 22,
    marginBottom: 66,
    textAlign: 'center',
  },
  viewButton: withSecondry => ({
    marginBottom: withSecondry ? 16 : 0,
  }),
  viewButtonText: {
    fontSize: Platform.OS === 'ios' ? 18.6 : 18,
  },
});
